export const articles = [
  {
    id: 'a1',
    title: '顶流男星深夜被拍到与神秘女子同行，工作室首次回应',
    summary:
      '昨晚有网友在某商圈偶遇一位人气男星与同行人员低调出行，画面曝光后迅速登上热搜，工作室随后发布简短声明。',
    cover:
      'https://readdy.ai/api/search-image?query=Night%20city%20street%20with%20warm%20orange%20streetlights%20and%20blurred%20crowd%2C%20cinematic%20moody%20atmosphere%2C%20abstract%20entertainment%20news%20visual%2C%20soft%20bokeh&width=800&height=600&seq=chigua-art-a1&orientation=landscape',
    category: 'hot-news',
    categoryName: '热点新闻',
    subCategory: 'star',
    subCategoryName: '明星动态',
    author: '瓜叔',
    source: '51吃瓜网 编辑部',
    publishTime: '2026-10-16T09:20:00',
    views: 128600,
    tags: ['明星动态', '热搜', '工作室回应'],
    hot: true,
    featured: true,
    content: [
      { type: 'paragraph', text: '昨晚有网友在某商圈偶遇一位人气男星与同行人员低调出行，现场画面很快在社交平台流传开来，相关话题数小时内冲上热搜前列，讨论量持续攀升。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Warm%20orange%20gradient%20abstract%20background%20with%20soft%20light%20streaks%2C%20modern%20editorial%20entertainment%20visual%2C%20minimal%20clean%20composition&width=1200&height=700&seq=chigua-body-a1&orientation=landscape', caption: '网友拍摄的画面在社交平台快速传播（示意图）' },
      { type: 'paragraph', text: '从流出的画面来看，当事人全程佩戴口罩与帽子，身边有几名工作人员随行，整体氛围较为谨慎。由于光线与角度限制，画面本身信息有限，但依然引发大量猜测。' },
      { type: 'quote', text: '工作室回应：感谢大家关心，希望外界给艺人保留正常的私人空间，后续工作安排将另行公布。' },
      { type: 'paragraph', text: '截至发稿，相关话题热度仍在持续。不少网友呼吁理性看待明星的私人行程，把注意力更多放在作品与公开活动上。我们也提醒大家，网络信息真假难辨，请以官方信息为准。' },
    ],
  },
  {
    id: 'a2',
    title: '年度盛典红毯造型大盘点，谁才是当晚最大赢家',
    summary:
      '年度娱乐盛典如期举行，红毯环节星光熠熠，各路艺人的造型成为网友热议焦点，我们整理了当晚最受关注的几套造型。',
    cover:
      'https://readdy.ai/api/search-image?query=Glamorous%20red%20carpet%20stage%20with%20golden%20spotlights%20and%20deep%20orange%20tones%2C%20elegant%20award%20ceremony%20atmosphere%2C%20abstract%20editorial%20backdrop&width=800&height=600&seq=chigua-art-a2&orientation=landscape',
    category: 'hot-news',
    categoryName: '热点新闻',
    subCategory: 'film',
    subCategoryName: '影视资讯',
    author: '小瓜',
    source: '51吃瓜网 时尚组',
    publishTime: '2026-10-15T21:05:00',
    views: 96400,
    tags: ['红毯造型', '盛典', '时尚'],
    hot: true,
    featured: true,
    content: [
      { type: 'paragraph', text: '一年一度的娱乐盛典如期举行，红毯环节依旧是全场焦点。当晚的造型风格多样，从简约高级到大胆张扬，几乎覆盖了所有审美取向。' },
      { type: 'paragraph', text: '从现场反馈看，剪裁利落的纯色礼服与质感面料成为主流选择，不少艺人选择以细节设计取胜，而非依靠夸张廓形吸引目光。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Backstage%20of%20an%20award%20ceremony%20with%20warm%20amber%20lighting%2C%20racks%20of%20elegant%20gowns%20in%20soft%20focus%2C%20editorial%20fashion%20mood&width=1200&height=700&seq=chigua-body-a2&orientation=landscape', caption: '后台准备区一角（示意图）' },
      { type: 'paragraph', text: '网友的讨论同样热闹，有人在社交平台发起投票，评选当晚最佳造型。整体来看，兼具个人风格与场合得体度的造型更容易获得好评。' },
    ],
  },
  {
    id: 'a3',
    title: '热门综艺突然宣布换人，节目组称因档期调整',
    summary:
      '开播以来口碑不俗的一档热门综艺突发公告，宣布常驻嘉宾阵容调整，节目组回应称属于正常的档期安排。',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20television%20studio%20with%20warm%20orange%20stage%20lights%20and%20empty%20host%20chairs%2C%20variety%20show%20set%20abstract%20visual%2C%20clean%20composition&width=800&height=600&seq=chigua-art-a3&orientation=landscape',
    category: 'hot-news',
    categoryName: '热点新闻',
    subCategory: 'show',
    subCategoryName: '综艺热播',
    author: '瓜妹',
    source: '51吃瓜网 综艺观察',
    publishTime: '2026-10-15T14:40:00',
    views: 74200,
    tags: ['综艺', '嘉宾调整', '节目组'],
    hot: true,
    featured: false,
    content: [
      { type: 'paragraph', text: '近日，一档开播以来热度不俗的综艺节目通过官方渠道发布公告，宣布对常驻嘉宾阵容进行调整，消息一出便登上热搜。' },
      { type: 'paragraph', text: '节目组在回应中表示，此次调整属于正常的档期安排，后续会有新的嘉宾加入，节目内容形式也会同步升级。' },
      { type: 'paragraph', text: '不少观众在评论区表达不舍，同时也对新人选表示期待。综艺换人在行业内并不罕见，最终效果如何，还需要看后续节目呈现。' },
    ],
  },
  {
    id: 'a4',
    title: '老牌乐队时隔八年再度合体巡演，门票开售即秒罄',
    summary:
      '一支陪伴听众多年的老牌乐队宣布时隔八年再度合体，开启全新巡演，多场次门票在开售后迅速售罄。',
    cover:
      'https://readdy.ai/api/search-image?query=Live%20concert%20stage%20with%20warm%20orange%20and%20amber%20lights%2C%20silhouettes%20of%20crowd%2C%20energetic%20music%20festival%20atmosphere%2C%20abstract%20visual&width=800&height=600&seq=chigua-art-a4&orientation=landscape',
    category: 'hot-news',
    categoryName: '热点新闻',
    subCategory: 'music',
    subCategoryName: '音乐现场',
    author: '现场君',
    source: '51吃瓜网 音乐组',
    publishTime: '2026-10-14T19:30:00',
    views: 68900,
    tags: ['巡演', '乐队', '门票'],
    hot: true,
    featured: false,
    content: [
      { type: 'paragraph', text: '时隔八年，一支陪伴无数听众成长的老牌乐队宣布再度合体，并启动新一轮巡演。消息公布后，相关话题热度迅速攀升。' },
      { type: 'paragraph', text: '据主办方介绍，本轮巡演将覆盖多个城市，曲目单会兼顾经典作品与新编版本，力求让不同年代的乐迷都能找到共鸣。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Concert%20hall%20interior%20with%20warm%20golden%20stage%20lighting%20and%20shallow%20depth%20of%20field%2C%20music%20event%20editorial%20visual&width=1200&height=700&seq=chigua-body-a4&orientation=landscape', caption: '巡演现场氛围（示意图）' },
      { type: 'paragraph', text: '门票开售当天，多场次迅速售罄。有乐迷表示，能再次在现场听到熟悉的旋律，本身就是一件值得纪念的事。' },
    ],
  },
  {
    id: 'a5',
    title: '新剧开播首日播放量破纪录，观众口碑呈现两极分化',
    summary:
      '一部备受期待的新剧正式开播，首日播放数据亮眼，但观众评价出现明显分歧，讨论集中在剧情节奏与人物设定上。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinema%20style%20dark%20theater%20with%20warm%20orange%20projector%20glow%2C%20abstract%20film%20reel%20motif%2C%20editorial%20entertainment%20visual%2C%20soft%20bokeh&width=800&height=600&seq=chigua-art-a5&orientation=landscape',
    category: 'hot-news',
    categoryName: '热点新闻',
    subCategory: 'film',
    subCategoryName: '影视资讯',
    author: '瓜叔',
    source: '51吃瓜网 影视组',
    publishTime: '2026-10-14T10:15:00',
    views: 82100,
    tags: ['新剧', '播放量', '口碑'],
    hot: false,
    featured: false,
    content: [
      { type: 'paragraph', text: '一部从立项起就备受关注的新剧正式开播，首日播放数据表现亮眼，相关话题占据多个热搜位置。' },
      { type: 'paragraph', text: '不过，观众评价呈现明显分歧。喜欢的一方认为画面质感与演员表现可圈可点，持保留意见的一方则认为前几集节奏偏慢，人物动机交代不够充分。' },
      { type: 'paragraph', text: '有观众表示，一部剧的完整质量往往需要更多集数才能判断，前期的争议未必代表整体水准，不妨再观望几集。' },
    ],
  },
  {
    id: 'a6',
    title: '知情人爆料：某剧组内部矛盾升级，多位主演临时改档',
    summary:
      '有业内人士向本站透露，某在拍剧组近期出现了协调问题，导致部分主演的行程临时调整，具体情况仍在核实。',
    cover:
      'https://readdy.ai/api/search-image?query=Empty%20film%20set%20with%20warm%20amber%20work%20lights%20and%20camera%20rig%20in%20soft%20focus%2C%20moody%20editorial%20atmosphere&width=800&height=600&seq=chigua-art-a6&orientation=landscape',
    category: 'expose',
    categoryName: '爆料报道',
    subCategory: 'exclusive',
    subCategoryName: '独家爆料',
    author: '爆料组',
    source: '51吃瓜网 独家',
    publishTime: '2026-10-16T08:10:00',
    views: 153200,
    tags: ['独家爆料', '剧组', '行程调整'],
    hot: true,
    featured: true,
    content: [
      { type: 'paragraph', text: '近日，有业内人士向本站透露，某在拍剧组近期在拍摄计划上出现了协调问题，部分主演的行程因此临时调整。' },
      { type: 'paragraph', text: '据该人士描述，问题主要出现在时间安排与场景筹备的衔接上，并非外界猜测的其他原因。截至目前，剧组方面尚未公开回应。' },
      { type: 'quote', text: '知情人：这类调整在行业里其实不算少见，关键看后续能否顺畅推进。' },
      { type: 'paragraph', text: '本站就此向多方求证，暂未获得明确答复。相关进展我们将持续关注，也提醒读者理性看待未经证实的说法。' },
    ],
  },
  {
    id: 'a7',
    title: '独家：某经纪公司被曝拖欠艺人分成，多方作出回应',
    summary:
      '有从业者反映，某经纪公司与旗下艺人之间存在分成结算争议，涉及多位艺人的合作款项，目前多方已作出初步回应。',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20office%20corridor%20with%20warm%20orange%20accent%20lighting%2C%20abstract%20corporate%20interior%2C%20editorial%20investigative%20mood&width=800&height=600&seq=chigua-art-a7&orientation=landscape',
    category: 'expose',
    categoryName: '爆料报道',
    subCategory: 'exclusive',
    subCategoryName: '独家爆料',
    author: '爆料组',
    source: '51吃瓜网 独家',
    publishTime: '2026-10-15T16:25:00',
    views: 118400,
    tags: ['独家爆料', '经纪公司', '分成争议'],
    hot: true,
    featured: false,
    content: [
      { type: 'paragraph', text: '有从业者向本站反映，某经纪公司与旗下艺人之间存在分成结算方面的争议，涉及多位艺人的合作款项。' },
      { type: 'paragraph', text: '据称，争议的核心在于部分项目的结算周期与账目透明度，双方此前曾进行过沟通，但暂未达成一致。' },
      { type: 'paragraph', text: '针对上述说法，涉事公司回应称相关款项正在按流程处理，具体以官方信息为准。本站将继续跟进，并保持信息中立。' },
    ],
  },
  {
    id: 'a8',
    title: '深扒某热播剧选角内幕，原定女主人选另有其人',
    summary:
      '围绕一部热播剧的选角过程，业内流传出多个版本的说法。我们梳理了公开信息，尝试还原大致的选角脉络。',
    cover:
      'https://readdy.ai/api/search-image?query=Casting%20room%20with%20warm%20amber%20lamp%20light%20and%20audition%20notes%20on%20a%20wooden%20desk%2C%20editorial%20documentary%20mood&width=800&height=600&seq=chigua-art-a8&orientation=landscape',
    category: 'expose',
    categoryName: '爆料报道',
    subCategory: 'insider',
    subCategoryName: '内幕追踪',
    author: '瓜叔',
    source: '51吃瓜网 深度组',
    publishTime: '2026-10-14T13:20:00',
    views: 90300,
    tags: ['选角内幕', '热播剧', '深度'],
    hot: false,
    featured: false,
    content: [
      { type: 'paragraph', text: '一部热播剧的成功，让外界对其选角过程产生了浓厚兴趣。近期业内流传出多个版本的说法，真假难辨。' },
      { type: 'paragraph', text: '我们梳理了公开资料与从业者的描述，可以确认的是，一部剧的主演人选通常会经历多轮试镜与沟通，最终结果往往取决于档期、气质匹配等多重因素。' },
      { type: 'paragraph', text: '对于流传的"原定人选"说法，目前尚无权威信息可以佐证。理性来看，选角本身是创作的一部分，最终呈现效果才是对选择最好的回答。' },
    ],
  },
  {
    id: 'a9',
    title: '某品牌代言风波后续：双方已低调解约',
    summary:
      '此前引发讨论的品牌代言合作出现新进展，据接近双方的人士称，相关合作已低调结束，双方暂未发布正式声明。',
    cover:
      'https://readdy.ai/api/search-image?query=Minimal%20brand%20campaign%20backdrop%20with%20warm%20orange%20gradient%20and%20clean%20empty%20space%2C%20editorial%20commercial%20visual&width=800&height=600&seq=chigua-art-a9&orientation=landscape',
    category: 'expose',
    categoryName: '爆料报道',
    subCategory: 'insider',
    subCategoryName: '内幕追踪',
    author: '瓜妹',
    source: '51吃瓜网 商业观察',
    publishTime: '2026-10-13T18:50:00',
    views: 71500,
    tags: ['代言', '解约', '商业'],
    hot: false,
    featured: false,
    content: [
      { type: 'paragraph', text: '此前引发广泛讨论的一桩品牌代言合作，近日有了新的进展。据接近双方的人士透露，相关合作已经低调结束。' },
      { type: 'paragraph', text: '该人士表示，双方以相对平和的方式处理了后续事宜，并未对外大肆宣传。截至目前，品牌方与艺人团队均未发布正式声明。' },
      { type: 'paragraph', text: '品牌代言本是常见的商业合作，出现调整也属正常。对吃瓜群众而言，关注作品与产品本身，或许比猜测更有意义。' },
    ],
  },
  {
    id: 'a10',
    title: '业内人士爆料颁奖礼投票机制，引发网友热议',
    summary:
      '有业内人士在公开场合谈及颁奖礼的投票与评审流程，相关说法在网络上引发讨论，不少网友表示第一次了解到具体环节。',
    cover:
      'https://readdy.ai/api/search-image?query=Award%20trophy%20silhouette%20on%20a%20dark%20stage%20with%20warm%20golden%20rim%20light%2C%20editorial%20ceremony%20visual&width=800&height=600&seq=chigua-art-a10&orientation=landscape',
    category: 'expose',
    categoryName: '爆料报道',
    subCategory: 'industry',
    subCategoryName: '行业观察',
    author: '观察员',
    source: '51吃瓜网 行业组',
    publishTime: '2026-10-13T11:05:00',
    views: 58200,
    tags: ['颁奖礼', '投票机制', '行业'],
    hot: false,
    featured: false,
    content: [
      { type: 'paragraph', text: '近日，一位业内人士在公开活动中谈及颁奖礼的投票与评审流程，相关说法在网络上迅速引发讨论。' },
      { type: 'paragraph', text: '据其介绍，多数颁奖礼的最终结果通常由大众投票与专业评审两部分共同决定，两者权重根据不同奖项有所差异。' },
      { type: 'paragraph', text: '不少网友留言表示，此前并不了解这些环节，了解之后对结果会多一分理解。也有声音认为，无论机制如何，作品质量始终是关键。' },
    ],
  },
  {
    id: 'a11',
    title: '明星童年照大合集，网友直呼"基因太强大"',
    summary:
      '一组明星童年照片在社交平台流传，多位艺人小时候的模样与现在对比，引发网友热烈讨论。',
    cover:
      'https://readdy.ai/api/search-image?query=Nostalgic%20warm%20photo%20album%20flat%20lay%20with%20orange%20tinted%20memories%2C%20soft%20editorial%20still%20life%2C%20cozy%20tones&width=800&height=600&seq=chigua-art-a11&orientation=landscape',
    category: 'web-fun',
    categoryName: '网络趣闻',
    subCategory: 'moment',
    subCategoryName: '名场面',
    author: '趣味组',
    source: '51吃瓜网 趣闻组',
    publishTime: '2026-10-16T10:45:00',
    views: 137500,
    tags: ['童年照', '对比', '网友热议'],
    hot: true,
    featured: true,
    content: [
      { type: 'paragraph', text: '近日，一组明星童年照片在社交平台流传，多位艺人小时候的模样被网友拿来与现在做对比，话题热度一路走高。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Vintage%20photo%20album%20pages%20with%20warm%20sepia%20and%20orange%20tones%2C%20soft%20editorial%20flat%20lay%2C%20nostalgic%20mood&width=1200&height=700&seq=chigua-body-a11&orientation=landscape', caption: '网友整理的照片合集（示意图）' },
      { type: 'paragraph', text: '评论区里，"基因太强大了""原来从小就是这个眼神"等留言频频出现。也有人感慨，时间过得真快，一转眼偶像都已经成长为如今的模样。' },
      { type: 'paragraph', text: '当然，也有理性网友提醒，童年照片属于个人成长记忆，传播时应注意尊重与适度，不必过度解读。' },
    ],
  },
  {
    id: 'a12',
    title: '综艺名场面再度出圈，这段对话被做成表情包',
    summary:
      '一段早前的综艺片段近期再度走红，节目中的经典对话被网友制作成表情包，在社交平台广泛使用。',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20colorful%20speech%20bubble%20pattern%20on%20warm%20orange%20background%2C%20abstract%20meme%20visual%2C%20clean%20flat%20design&width=800&height=600&seq=chigua-art-a12&orientation=landscape',
    category: 'web-fun',
    categoryName: '网络趣闻',
    subCategory: 'meme',
    subCategoryName: '网友热议',
    author: '趣味组',
    source: '51吃瓜网 趣闻组',
    publishTime: '2026-10-15T20:10:00',
    views: 109800,
    tags: ['名场面', '表情包', '热梗'],
    hot: true,
    featured: false,
    content: [
      { type: 'paragraph', text: '一段早前的综艺片段近期再度走红，节目中的经典对话被网友截图并配上文字，制作成各式各样的表情包。' },
      { type: 'paragraph', text: '如今，这套表情包已经出现在不少人的日常聊天里，成为表达情绪的常用素材，相关话题也顺势登上热搜。' },
      { type: 'paragraph', text: '有网友表示，好的综艺片段能穿越时间，隔了这么久再看依旧好笑，这大概就是"名场面"的魅力所在。' },
    ],
  },
  {
    id: 'a13',
    title: '粉丝接机现场变"大型社死现场"，画面笑翻网友',
    summary:
      '一则粉丝接机视频在网络走红，现场因沟通误会出现了尴尬又欢乐的一幕，评论区直呼"太真实了"。',
    cover:
      'https://readdy.ai/api/search-image?query=Airport%20terminal%20interior%20with%20warm%20orange%20ambient%20light%20and%20blurred%20crowd%2C%20editorial%20documentary%20mood%2C%20soft%20focus&width=800&height=600&seq=chigua-art-a13&orientation=landscape',
    category: 'web-fun',
    categoryName: '网络趣闻',
    subCategory: 'daily',
    subCategoryName: '明星日常',
    author: '瓜妹',
    source: '51吃瓜网 趣闻组',
    publishTime: '2026-10-14T22:35:00',
    views: 88700,
    tags: ['接机', '社死现场', '欢乐'],
    hot: false,
    featured: false,
    content: [
      { type: 'paragraph', text: '一则粉丝接机视频近日在网络走红，现场因为沟通上的误会，出现了一幕既尴尬又欢乐的场景。' },
      { type: 'paragraph', text: '视频中，几位粉丝认错了方向，在原地等待许久后才恍然大悟，画面被同行网友记录下来并分享，迅速引发围观。' },
      { type: 'paragraph', text: '评论区里"太真实了""代入感极强"的留言不断。也有人提醒，接机时注意安全与秩序，理性追星才是最好的方式。' },
    ],
  },
  {
    id: 'a14',
    title: '网友神还原经典角色，对比图流出引发热议',
    summary:
      '一位网友发布了一组模仿经典影视角色的照片，从造型到神态高度还原，对比图流出后获得大量点赞。',
    cover:
      'https://readdy.ai/api/search-image?query=Costume%20rack%20with%20colorful%20vintage%20outfits%20and%20warm%20orange%20backlight%2C%20creative%20cosplay%20editorial%20visual%2C%20soft%20focus&width=800&height=600&seq=chigua-art-a14&orientation=landscape',
    category: 'web-fun',
    categoryName: '网络趣闻',
    subCategory: 'meme',
    subCategoryName: '网友热议',
    author: '趣味组',
    source: '51吃瓜网 趣闻组',
    publishTime: '2026-10-14T09:15:00',
    views: 76300,
    tags: ['模仿', '对比图', '神还原'],
    hot: false,
    featured: false,
    content: [
      { type: 'paragraph', text: '近日，一位网友发布了一组模仿经典影视角色的照片，从服装配色到神态气质都下足了功夫，几乎做到了神还原。' },
      { type: 'paragraph', text: '这组照片与原片画面的对比图流出后，迅速获得大量点赞。不少网友留言称赞其用心程度，也有人表示被唤起了当年的追剧回忆。' },
      { type: 'paragraph', text: '创作者在评论区表示，模仿的初衷是致敬与分享，希望大家在娱乐的同时，也能尊重原创作品的版权。' },
    ],
  },
  {
    id: 'a15',
    title: '剧组花絮曝光，演员片场反差萌圈粉无数',
    summary:
      '随着一组片场花絮视频曝光，演员们在镜头外的真实状态让不少观众直呼反差萌，相关话题阅读量持续走高。',
    cover:
      'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20warm%20orange%20work%20lights%20and%20cozy%20crew%20area%2C%20editorial%20documentary%20visual%2C%20soft%20focus&width=800&height=600&seq=chigua-art-a15&orientation=landscape',
    category: 'web-fun',
    categoryName: '网络趣闻',
    subCategory: 'daily',
    subCategoryName: '明星日常',
    author: '现场君',
    source: '51吃瓜网 花絮组',
    publishTime: '2026-10-13T15:40:00',
    views: 69800,
    tags: ['花絮', '反差萌', '片场'],
    hot: false,
    featured: false,
    content: [
      { type: 'paragraph', text: '随着一组片场花絮视频曝光，演员们在镜头外的真实状态被更多人看到，不少观众直呼"太可爱了"。' },
      { type: 'paragraph', text: '视频里，紧张的拍摄间隙穿插着轻松的互动，有人对台词，有人在角落补充能量，氛围既专业又温暖。' },
      { type: 'paragraph', text: '有网友表示，正是这些真实的细节，让角色之外的人更有人情味，也因此更愿意去关注作品本身。' },
    ],
  },
];